import { useUploadHistory } from './SVCManageHistory.hooks'
import classes from './SVCManageHistory.module.css';
import SVCManageHistoryTable from '../../shared/SVCManageHistoryTable/SVCManageHistoryTable';
const SVCManageHistory = () => {
    const { uploadHistory, loading} = useUploadHistory();
    return (
        <div className={classes.body}>
            <div className={classes.heading}>SVC MANAGE HISTORY</div>
        <div className={classes.fileuploadHistory}>
            
        <SVCManageHistoryTable uploadHistory={uploadHistory} isPaginationRequired={true} loading={loading}/>
            
        </div>
    </div>
    )
}

export default SVCManageHistory;